var map = {
	"./favicon.png": "a171",
	"./logo-adon.png": "10ce",
	"./pinwall-logo-mobile - Copy.svg": "335f",
	"./pinwall-logo-mobile.svg": "68b8",
	"./pinwall-logo-new - Copy.svg": "ec31",
	"./pinwall-logo-new-dark.svg": "0117",
	"./pinwall-logo-new.svg": "7373",
	"./pinwall-logo.svg": "6865",
	"./swisstxt.png": "0f5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e1";